import React, { useEffect, useRef } from "react";
import classNames from "classnames/bind";
import UIIcon from "common/blocks/UIIcon";

import styles from "../Sidebar.module.scss";
import IconButton from "common/blocks/IconButton";

const cx = classNames.bind(styles);

const Panel = React.forwardRef((props: any, ref: any) => {
    const contentRef = useRef<HTMLDivElement | null>(null);

    const {
        title,
        onClose,
        onGoBack,
        previousModal,
        footerComponent: Footer,
        children,
        className,
        disableScroll,
    } = props as any;

    const hasFooter = !!Footer;

    useEffect(() => {
        contentRef.current?.scrollTo(0, 0);
    });

    return (
        <div className={cx("sidebar", className)} ref={ref}>
            <div className={cx("heading")}>
                <div className={cx("goBackAndTitle")}>
                    {previousModal && (
                        <IconButton
                            className={cx("goBackButton")}
                            title="Go back"
                            aria-label="Go back"
                            onClick={onGoBack}
                            icon="ChevronLeft"
                        />
                    )}
                    <span className={cx("title")}>{title}</span>
                </div>

                <IconButton
                    title="Close Modal"
                    aria-label="Close Modal"
                    onClick={onClose}
                    icon="Close"
                />
            </div>
            <div
                id="sidebar-content"
                ref={contentRef}
                className={cx("content", { disableScroll, hasFooter })}
            >
                {children}
            </div>
            {Footer && (
                <div className={cx("footer")}>
                    <Footer />
                </div>
            )}
        </div>
    );
});

Panel.displayName = "Panel";

export default Panel;
